import React from 'react'

export default function Footer() {
  return (
    <p className='Footer center'>&copy; Task Zen 2024 (Chingu Voyage 47, Team 27)</p>
  )
}
